import { Navigate, Route, Routes } from "react-router-dom";
import "./index.css"; // Tailwind CSS

import ForgottenPass from "./containers/auth/forgotpass.jsx";
import Login from "./containers/auth/Login";
import Registration from "./containers/auth/Registration";
import MainLayout from "./containers/layout";
import "antd/dist/reset.css";
import ProtectedRoute from "./otherRoutes/ProtectedRoute.jsx";
import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";

function App() {
  // Use localStorage to check if user is

  useEffect(() => {
    if ("Notification" in window) {
      if (Notification.permission === "default") {
        Notification.requestPermission().then((permission) => {
          // console.log("Notification permission:", permission);
        });
      }
    }
  }, []);

  const isUserLogin = localStorage.getItem("isLogin") === "true";

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp) {
          const timeLeft = decoded.exp - currentTime;
          if (timeLeft > 0) {
            const timer = setTimeout(() => {
              localStorage.clear();
              window.location.href = "/login"; // force logout
            }, timeLeft * 1000);

            return () => clearTimeout(timer);
          } else {
            localStorage.clear();
            window.location.href = "/login";
          }
        }
      } catch (err) {
        // console.error("Invalid token:", err);
        localStorage.clear();
        window.location.href = "/login";
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-app-wallpaper overflow-auto">
     
        <Routes>
          <Route
            path="/login"
            element={
              isUserLogin && localStorage.getItem("token") ? (
                <Navigate to="/chats" replace />
              ) : (
                <Login />
              )
            }
          />

          <Route path="/registration" element={<Registration />} />
          <Route path="/forgotpass" element={<ForgottenPass />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          />
        </Routes>
     
    </div>
  );
}

export default App;
